<div id="uiMenu">
  <button
    id="hideUIMenu"
    type="button"
    aria-label="Toggle toolbar visibility"
    [matTooltip]="hideUIMenu ? 'Show toolbar' : 'Hide toolbar'"
    matTooltipPosition="above"
    (click)="hideUIMenu = !hideUIMenu"
    [ngClass]="{ 'ui-menu-hidden': hideUIMenu }"
  >
    <svg>
      <use href="assets/icons/expand.svg#expand"></use>
    </svg>
  </button>
  <div id="optionsPanel" [hidden]="hideUIMenu">
    <ng-content></ng-content>
  </div>
</div>
<app-session-pill></app-session-pill>
